// Display metadata only. Canonical contract and inspection types still control
// scheduling, report storage and technician forms.
export const SERVICE_SCOPE_LABELS = {
  'dryer-vent': 'Dryer Vent',
  'interior-dryer': 'Interior Dryer',
  'kitchen-exhaust': 'Kitchen Exhaust',
  'bathroom-exhaust': 'Bathroom Exhaust',
  'kitchen-filter': 'Kitchen Filter',
};

export function scopeContract(record) {
  if (!record) return null;
  if (record.type) return record;
  const contracts = record.contractData || [];
  const indexed = Number.isInteger(record.contractIndex) ? contracts[record.contractIndex] : null;
  if (indexed && (!record.contractType || indexed.type === record.contractType)) return indexed;
  const matches = contracts.filter(c => c.type === (record.contractType || 'dryer-vent'));
  return matches.length === 1 ? matches[0] : null;
}

export function contractScopeLabel(record, fallback = 'Dryer Vent') {
  const contract = scopeContract(record);
  if (contract?.type !== 'dryer-vent' || contractScopeNeedsReview(contract)) return fallback;
  const labels = [...new Set(contract.serviceScope)].map(key => SERVICE_SCOPE_LABELS[key]);
  return labels.length ? labels.join(', ') : fallback;
}

export function contractScopeNeedsReview(record) {
  const contract = scopeContract(record);
  if ((contract?.type || record?.contractType) !== 'dryer-vent') return false;
  return contract?.serviceScopeStatus !== 'verified'
    || !Array.isArray(contract?.serviceScope)
    || !contract.serviceScope.length
    || contract.serviceScope.some(key => !SERVICE_SCOPE_LABELS[key]);
}

export function maintenanceScopeLabel(inspection, building, fallback = '') {
  const raw = inspection?.maintenanceType || inspection?.Type || fallback;
  // Use a persisted visit scope when available. Otherwise only expand the
  // dryer component; a contract never adds an unselected service to a visit.
  const snapshot = inspection?.serviceScopeStatus === 'verified' ? { ...inspection, type: 'dryer-vent' } : null;
  const status = String(inspection?.status || '').trim().toLowerCase();
  const today = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Toronto', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
  const end = String(inspection?.endTerm || inspection?.endDate || '').slice(0, 10);
  const historical = ['past', 'complete', 'completed', 'closed', 'cancelled', 'canceled'].includes(status)
    || (/^\d{4}-\d{2}-\d{2}$/.test(end) && end < today);
  if (historical && !snapshot) return raw;
  const contract = snapshot || scopeContract({ ...building, contractType: 'dryer-vent', contractIndex: undefined });
  const label = contractScopeLabel(contract, '');
  if (!label) return raw;
  return String(raw).replace(/dryer[\s_-]*vent|\bdryer\b/ig, label);
}
